import { AppLayout } from 'layouts';
import { HomeFeed } from 'features/feed';
import { Sidebar } from 'features/sidebar';
import { useFeedbackOptions } from 'pages/hooks';

const PageFeed = () => {
  const feedbackOptions = useFeedbackOptions();

  return (
    <AppLayout aside={<Sidebar feedbackOptions={feedbackOptions} hideTodosFeedCta />}>
      <HomeFeed />
    </AppLayout>
  );
};

export default PageFeed;
